/**
 * Envío ER-2 · Los toasts nunca reciben algo que React no pueda dibujar.
 *
 * Hay ~60 llamadas del estilo `toast.error(err.response?.data?.detail || '…')`.
 * En vez de tocarlas una por una, se envuelven una sola vez los métodos de
 * `toast` (sonner): el mensaje y la descripción pasan por `renderableText`.
 * Los textos y los elementos de React siguen igual que antes.
 */
import { toast as sonnerToast } from 'sonner';
import { renderableText } from './errorText';

const METHODS = ['error', 'warning', 'success', 'info', 'message', 'loading'];

export function installSafeToast(t = sonnerToast) {
  if (!t || t.__smlSafe) return t;
  METHODS.forEach((name) => {
    const original = t[name];
    if (typeof original !== 'function') return;
    t[name] = (message, options) => {
      const opts = options && typeof options === 'object' && 'description' in options
        ? { ...options, description: renderableText(options.description, '') }
        : options;
      return original.call(t, renderableText(message, ''), opts);
    };
  });
  Object.defineProperty(t, '__smlSafe', { value: true });
  return t;
}
